import script from "./VehicleVerifyImage.vue?vue&type=script&setup=true&lang=ts"
export * from "./VehicleVerifyImage.vue?vue&type=script&setup=true&lang=ts"

import "./VehicleVerifyImage.vue?vue&type=style&index=0&id=78af9661&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78af9661"]])

export default __exports__